import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    treeStructureNodeData: []
}

const treeStructureSlice = createSlice({
  name: 'treeStructure',
  initialState,
  reducers: {
    settreeStructureNodeData: (state, action) => {
      state.treeStructureNodeData = action.payload
    }
  }
})

export const { settreeStructureNodeData } = treeStructureSlice.actions

export default treeStructureSlice.reducer